<template>
  <a-modal :visible="visible"
           @ok="handleOk"
           @cancel="cancelRecharge"
           centered
           footer
           :width="500"
           title="">
    <div class="payment-modal-content">
      <div class="icon-title">
        <div class="wechatPay_icon"></div>
        <div class="icon-title-text">{{ $t('AccountInfo.BalanceRechargeWechat.wechatPayment') }}</div>
      </div>
      <div class="placeholder-text">
        {{ $t('AccountInfo.BalanceRechargeWechat.scanToPay') }}
      </div>

      <div class="qr-code">
        <img :src="qrCodeSrc"
             alt="QR Code"
             class="qr-code-placeholder" />
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import QRCode from 'qrcode'
import { nextTick, onMounted, ref, watch } from 'vue'
import { getStatusFromWechatRecharge } from '../api/balance'

const qrCodeSrc = ref<string>('')
const pollingIntervalId = ref()
const isPolling = ref(false)

const startPolling = () => {

  if (pollingIntervalId.value) return

  pollingIntervalId.value = setInterval(async () => {

    if (isPolling.value) return
    isPolling.value = true // 设置轮询状态为进行中

    try {
      const result = await getStatusFromWechatRecharge(props.orderNumber)
      if (result.status === 1 || result.status === 0) {
        handleCancel()  // 关闭模态框
      }
    } catch (error) {
      console.error('查询失败:', error)
    } finally {
      isPolling.value = false // 轮询完成，重置状态
    }
  }, 2000)
}


const stopPolling = () => {
  if (pollingIntervalId.value) {
    clearInterval(pollingIntervalId.value)
    pollingIntervalId.value = null
  }
  isPolling.value = false // 停止时重置轮询状态
}

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  url: {
    type: String,
    required: true
  },
  orderNumber: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['close'])

const handleOk = () => {
  emit('close')
}

const handleCancel = () => {
  stopPolling()
  emit('close')
}

const cancelRecharge = async () => {
  stopPolling()
  await getStatusFromWechatRecharge(props.orderNumber, 'true').then(() => {
    emit('close')
  })
}

const generateQRCode = async (url: string) => {
  try {
    const dataUrl = await QRCode.toDataURL(url, { width: 280 })
    qrCodeSrc.value = dataUrl
  } catch (error) {
    console.error('生成二维码失败:', error)
  }
}

onMounted(() => {
  if (props.visible) {
    nextTick(() => generateQRCode(props.url))
  }
})

watch(() => props.visible, async (newValue) => {
  if (newValue) {
    await nextTick()
    generateQRCode(props.url)
    startPolling()
  } else {
    stopPolling()
  }
});

</script>


<style scoped lang="less">
.payment-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}

.icon-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.wechatPay_icon {
  width: 34px;
  height: 34px;
  background: url(".././view/assets/imgs/balanceRecharge_wechat.png") no-repeat center / contain;
}

.icon-title-text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #111111;
  margin-left: 10px;
}

.placeholder-text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  margin-bottom: 25px;
}

.qr-code {
  border: 2px solid green;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
}

.qr-code-placeholder {
  width: 280px;
  height: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}
</style>
